import { env } from "./config";

const baseUrl = env.BASE_URL;

export function notNullOrUndefined(val) {
  return val !== null && val !== undefined;
}

export const getInventoryTypeTitle = (type) => {
  switch (type) {
    case "device":
      return "Device";
    case "sim":
      return "SIM";
    case "other":
      return "Other";
    default:
      return "-";
  }
};

export const copyToClipboard = async (text) => {
  if (!text && text !== "") return false;
  if (navigator.clipboard && navigator.clipboard.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      try {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.setAttribute("readonly", "");
        textarea.style.position = "absolute";
        textarea.style.left = "-9999px";
        document.body.appendChild(textarea);
        textarea.select();
        const successful = document.execCommand("copy");
        document.body.removeChild(textarea);
        return successful;
      } catch {
        return false;
      }
    }
  }
};

export const _downloadBlobFile = (response, defaultFileName) => {
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;

  let fileName = defaultFileName;

  console.log("Final fileName to download: ", fileName);

  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);

  return { is_error: 0, message: "File downloaded successfully" };
};

export const isNumber = (value) => {
  return value !== null && !Array.isArray(value) && !isNaN(Number(value));
};

export const toTitleCase = (str) => {
  return str.replace(/_/g, " ").replace(/\w\S*/g, (txt) => {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export const buildGetApiUrl = (path, params = {}) => {
  if (typeof path !== "string") {
    return baseUrl;
  }

  const url = new URL(path, baseUrl);

  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === undefined || value === "") {
      return;
    }

    if (Array.isArray(value)) {
      value.forEach((item) => {
        url.searchParams.append(key, item);
      });
      return;
    }

    url.searchParams.set(key, value);
  });

  return url.toString();
};

export const filterByUserScope = (item) => {
  const { userTypes, managerTypes, scopes } = item;

  const authScope = localStorage.getItem("scope");
  const authUserType = JSON.parse(localStorage.getItem("currUserType"));
  const authManagerType = JSON.parse(localStorage.getItem("currManagerType"));
  if (!authUserType || !authScope) {
    return false;
  }
  const scopeAllowed = !scopes || scopes.includes(authScope);
  const userTypeAllowed = !userTypes || userTypes.includes(authUserType);
  const managerTypeAllowed =
    !authManagerType || !managerTypes || managerTypes.includes(authManagerType);

  return scopeAllowed && userTypeAllowed && managerTypeAllowed;
};
